import React from 'react';
import { Hero } from './components/Hero';
import { MechanismReveal } from './components/MechanismReveal';
import { OfferStack } from './components/OfferStack';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { ReviewSection } from './components/ReviewSection';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { UrgencyBanner } from './components/UrgencyBanner';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <main className="min-h-screen bg-navy-900 selection:bg-gold selection:text-navy-900 pt-12" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <MechanismReveal data-id="element-3" />
      <OfferStack data-id="element-4" />
      <Pricing data-id="element-5" />
      <Testimonials data-id="element-6" />
      <ReviewSection data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchaseNotification data-id="element-11" />
    </main>;
}